import { render, staticRenderFns } from "./FileDropZone.vue?vue&type=template&id=a6e5d266&scoped=true"
import script from "./FileDropZone.vue?vue&type=script&lang=js"
export * from "./FileDropZone.vue?vue&type=script&lang=js"
import style0 from "./FileDropZone.vue?vue&type=style&index=0&id=a6e5d266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e5d266",
  null
  
)

export default component.exports